module.exports = __webpack_public_path__ + "img/bg-request-refund-success-ad-solutions.682ce089.jpg";